import type { CreateClienteInmobiliarioModel, SubtipoPersonaEnum } from '@api/api';
import { TipoDocumentoEnum, TipoPersonaEnum } from '@api/api';

export class CreateClienteInmobiliario implements CreateClienteInmobiliarioModel {
    TipoPersona: TipoPersonaEnum = TipoPersonaEnum.Fisica;
    SubtipoPersona: SubtipoPersonaEnum | null = null;
    RazonSocial: string | null = null;
    CIF: string | null = null;
    Nombre: string = null!;
    Apellidos: string = null!;
    Documento: string = null!;
    Telefono: string | null = null;
    TelFijo: string | null = null;
    TelMovil: string | null = null;
    Email: string = null!;
    FechaNacimiento: string | null = null;
    RutaDocumento: string | null = null;
    IbanPago: string | null = null;
    NombrePago: string | null = null;
    TipoDocumentoPago: TipoDocumentoEnum | null = null;
    DocumentoPago: string | null = null;
    ApellidosPago: string | null = null;

    constructor(data?: Partial<CreateClienteInmobiliario>) {
        Object.assign(this, data);
    }
}